<template>
    <div class="offcnvas_header" v-if="userHeader">
        <template>
            <div class="offcnvas_header__img">
                <img :src="image" :alt="alt" />
            </div>
            <div class="offcnvas_header__text">
                <h4>{{ username }}</h4>
                <p>{{ useremail }}</p>
                <h5>{{ companyname }}</h5>
            </div>
        </template>
    </div>
    <div v-else>
        <slot></slot>
    </div>
</template>

<script setup>
const props = defineProps({
    image: {
        type: String,
        default: ""
    },
    alt: {
        type: String,
        default: ""
    },
    username: {
        type: String,
        default: ""
    },
    useremail: {
        type: String,
        default: ""
    },
    companyname: {
        type: String,
        default: ""
    },
    userHeader: {
        type: Boolean,
        default: false,
    }
});
</script>

<style scoped>
.offcnvas_header {
    @apply flex flex-col items-center justify-center mb-6;
}

.offcnvas_header__img {
    @apply mb-6 w-[11.75rem] h-[11.75rem] rounded-full object-cover overflow-hidden;
}

.offcnvas_header__text {
    @apply text-center;
}

.offcnvas_header__text h4 {
    @apply mb-2 text-lg font-medium text-dark-200 dark:text-white;
}

.offcnvas_header__text p {
    @apply mb-2 text-base font-light text-dark-200 dark:text-white;
}

.offcnvas_header__text h5 {
    @apply mb-0 text-base font-normal text-dark-200 dark:text-white;
}
</style>
